import { Controller } from "@hotwired/stimulus"

// Submits the events filter form when the time filter changes.
// Status filtering moved to the pipeline segment bar (events/partials/_pipeline);
// the active status_filter[] rides along as hidden fields in this form.
export default class extends Controller {
  static targets = ["form"]

  timeFilterChanged() {
    // requestSubmit(), not submit(): a native submit() bypasses Turbo entirely,
    // which would lose the form's data-turbo-frame (and with it the events_list
    // frame navigation Events::FilterPersistable reads as an explicit filter
    // change). Fall back to submit() only where requestSubmit is unavailable.
    if (typeof this.formTarget.requestSubmit === "function") {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }
}
